import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const cssVariantSimple = css `
  ${({ theme, isOpened }) => isOpened &&
    `
    background: ${theme.Color.Neutrals.Light};
  `}

  &:hover {
    background: ${({ theme }) => theme.Color.Neutrals.Light};
    transition: all ${({ theme }) => theme.Transition.Timing.In};
  }
`;
export const cssVariantOutline = css `
  border: 1px solid ${({ theme }) => theme.Color.Neutrals.Border};
`;
export const cssVariantGhost = css `
  border: 0;
`;
export const StyledWrapper = styled.div `
  display: flex;
  width: 100%;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  background: transparent;
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  transition: all ${({ theme }) => theme.Transition.Timing.Out};

  ${({ variant }) => {
    switch (variant) {
        case 'outline':
            return cssVariantOutline;
        case 'simple':
            return cssVariantSimple;
        case 'ghost':
            return cssVariantGhost;
        default:
            return '';
    }
}}
`;
export const StyledLabel = styled.div `
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  cursor: pointer;
  user-select: none;

  ${({ theme, variant, isOpened }) => {
    switch (variant) {
        case 'outline':
            return `
        border-bottom: 1px solid ${isOpened ? theme.Color.Neutrals.Border : 'transparent'};`;
        case 'simple':
            return `
          padding: ${rem(theme.Spacing.Size.XSmall)};
        `;
        case 'ghost':
            return `
          padding: ${rem(theme.Spacing.Size.XSmall)};
          padding-left: 0;
        `;
        default:
            return '';
    }
}}
`;
export const StyledIconWrapper = styled.div `
  display: inline-flex;
  margin-right: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyledLabelTextWrapper = styled.div ``;
export const StyledLabelExtraWrapper = styled.div `
  margin-left: auto;
`;
export const StyledContentWrapper = styled.div `
  display: flex;
  width: 100%;

  & > div {
    width: 100%;
  }
`;
export const StyledContent = styled.div `
  width: 100%;

  ${({ theme, variant }) => {
    switch (variant) {
        case 'outline':
            return `padding: ${rem(theme.Spacing.Size.Small)};`;
        case 'simple':
            return `padding: ${rem(theme.Spacing.Size.XSmall)};`;
        default:
            return '';
    }
}}
`;
export const StyledList = styled.ul `
  display: flex;
  gap: ${({ theme, variant }) => variant === 'full'
    ? rem(theme.Spacing.Size.Small)
    : rem(theme.Spacing.Size.XSmall)};
  width: 100%;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: left;
`;
export const StyledListItem = styled.li `
  display: inline-flex;
  width: ${({ variant }) => (variant === 'full' ? '100%' : 'auto')};
`;
//# sourceMappingURL=Collapse.style.js.map